import { styled } from '@openeducation/oe-it-themes';
import React, { useState } from 'react';
import {
  LayoutChangeEvent,
  StyleProp,
  TouchableWithoutFeedback,
  ViewStyle,
} from 'react-native';

import {
  ProgressBarBar,
  ProgressBarPointer,
  ProgressBarPopup,
} from './components';
import { height } from '../../style-utils';

export interface ProgressBarProps {
  delay?: number;
  percentage: number;
  pointerPercentage?: number;
  showPopup?: boolean;
  showPointer?: boolean;
  style?: StyleProp<ViewStyle>;
  barWrapperStyle?: StyleProp<ViewStyle>;
  barStyle?: StyleProp<ViewStyle>;
  pointerStyle?: StyleProp<ViewStyle>;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  delay = 300,
  percentage,
  pointerPercentage,
  showPopup = true,
  showPointer,
  style,
  barWrapperStyle,
  barStyle,
  pointerStyle,
}) => {
  const [barWidth, setBarWidth] = useState(0);
  const handleProgressBarLayout = (event: LayoutChangeEvent) => {
    event?.persist?.();
    setBarWidth(event?.nativeEvent?.layout?.width);
  };

  const [isProgressLabelVisible, setProgressLabelVisibility] =
    useState(showPopup);
  const toggleMobileProgressLabelVisibility = () => {
    if (showPopup) {
      return;
    }
    setProgressLabelVisibility(!isProgressLabelVisible);
  };

  const mouseEvents = {
    onMouseEnter: () => setProgressLabelVisibility(true),
    onMouseLeave: () => setProgressLabelVisibility(false),
  };

  return (
    <Container style={style}>
      {isProgressLabelVisible && (
        <ProgressBarPopup
          isVisible={isProgressLabelVisible}
          delay={delay + (showPopup ? 500 : 0)}
          barWidth={barWidth}
          percentage={percentage}
        />
      )}

      <TouchableWithoutFeedback
        onPress={toggleMobileProgressLabelVisibility}
        {...mouseEvents}
        hitSlop={{ top: 20, bottom: 20 }}
      >
        <BarWrapper
          onLayout={handleProgressBarLayout}
          style={[barWrapperStyle, showPointer && height(6)]}
        >
          <ProgressBarBar
            percentage={percentage}
            delay={delay}
            style={[barStyle, showPointer && height(6)]}
          />
          {showPointer && (
            <ProgressBarPointer
              percentage={percentage}
              pointerPercentage={
                pointerPercentage ?? (showPointer ? percentage : 0)
              }
              delay={delay}
              style={[pointerStyle]}
            />
          )}
        </BarWrapper>
      </TouchableWithoutFeedback>
    </Container>
  );
};

const Container = styled.View`
  flex: 1;
  width: 100%;
`;

const BarWrapper = styled.View`
  height: 4px;
  border-radius: 2px;
  width: 100%;
  background-color: ${({ theme }) => theme.color.lightPrimary};
  flex-direction: row;
`;
